export default __webpack_public_path__ + "static/media/brandGuidelinesImagePage30.f08bf5fc.png";